import { runInAction } from 'mobx';

import { GamesList, gamesList } from '@/games';
import { GameInfo } from '@/types';
import { result } from '../utils/mobx/mobx';
import { ToastManager } from './ToastManager';

export const GAME_LIST_URL = 'https://tpg-list.pages.dev/games.json';

export abstract class BaseAppModel {
  games = new Map<string, GameInfo>();
  gamesList: Record<string, string | null> = { ...gamesList };
  gamesLoaded = false;
  selectedGame: GameInfo | null = null;
  devMode: boolean = false;
  devGameUrl: string | null = null;
  abstract toastManager: ToastManager;
  abstract uuid?: string;
  forceShowExitButton: boolean = false;
  showHiddenGames: boolean = false;

  constructor() {}

  fetchGameListPromise: Promise<void> | null = null;

  abstract trySelectGame(gameUniqueName: string): boolean;

  async init() {
    this.fetchGameListPromise = new Promise(async (res) => {
      await this.fetchGameList();
      res();
    });

    this.loadGames();
  }

  *fetchGameList() {
    const fetchResult = yield* result(fetch(GAME_LIST_URL));

    if (!fetchResult.ok) {
      return;
    }

    const gameData = (yield* result(fetchResult.json())) as GameInfo[];

    const newGamesList = gameData.reduce(
      (acc, gameInfo) => {
        acc[gameInfo.uniqueName] = gameInfo.endpoints.info;
        return acc;
      },
      {} as Record<string, string | null>,
    );

    console.log(newGamesList);

    runInAction(() => {
      this.gamesList = newGamesList;
    });
  }

  async getGame(gameUniqueName: string): Promise<GameInfo | undefined> {
    let game = this.games.get(gameUniqueName);

    if (!game) {
      await this.loadGames();
      game = this.games.get(gameUniqueName);
    }

    return game;
  }

  async loadGames() {
    console.log('loading games');

    await this.fetchGameListPromise;
    const gamesEntries = Object.entries(this.gamesList);

    const gamesData = (
      await Promise.all(
        gamesEntries.map(async ([id, url]) => {
          if (url === null) {
            return null;
          }

          try {
            // disable cores
            const gameDataRes = await fetch(url);
            const gameData = await gameDataRes.json();

            return {
              id,
              gameData,
            };
          } catch {
            return null;
          }
        }),
      )
    ).filter(
      (gameData): gameData is { id: keyof GamesList; gameData: GameInfo } =>
        gameData !== null,
    );

    runInAction(() => {
      for (const { gameData, id } of gamesData) {
        // TODO: make this more type safe
        this.games.set(id === 'dev' ? id : gameData.uniqueName, gameData as GameInfo);
      }

      this.gamesLoaded = true;
    });
  }
}
